module.exports = __webpack_public_path__ + "img/banner.d72db61c.png";